exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-post .vue-treeselect__menu-container,\n.create-post .vue-treeselect__menu-container .vue-treeselect__menu {\n  position: relative;\n}", ""]);

// exports
